import * as React from 'react';

export const Container: React.FC = ({ children }) => <div className="container">{children}</div>;
